import { render, staticRenderFns } from "./SearchBoxV3.vue?vue&type=template&id=73fa11fa&scoped=true&"
import script from "./SearchBoxV3.vue?vue&type=script&lang=ts&"
export * from "./SearchBoxV3.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBoxV3.vue?vue&type=style&index=0&id=73fa11fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa11fa",
  null
  
)

export default component.exports